import axios from "axios";
import app from "../_app";

const cart = document.querySelector('.js-cart');

if(cart) {
    const cartProducts = [...document.querySelectorAll('.js-cart-product')];
    const cartEmpty = document.querySelector('.js-cart-empty');
    const cartTotalPrice = document.querySelector('.js-cart-total-price');
    const cartCheckout = document.querySelector('.js-cart-checkout');

    cartCheckout.addEventListener('click', () => cartCheckout.setAttribute('data-state', 'loading'));

    const cartProductInit = cartProduct => {
        const id = +cartProduct.dataset.id;

        const quantityField = cartProduct.querySelector('.js-cart-product-quantity-field');
        const quantityMinus = cartProduct.querySelector('.js-cart-product-quantity-minus');
        const quantityPlus = cartProduct.querySelector('.js-cart-product-quantity-plus');
        const remove = cartProduct.querySelector('.js-cart-product-remove');
        const price = cartProduct.querySelector('.js-cart-product-price');

        let latestRequestQuantity = +quantityField.value;

        quantityMinus.addEventListener('click', () => {
            let quantity = +quantityField.value;
            quantity--

            quantityField.value = quantity;
            quantityField.dispatchEvent(new Event('change'));
        });

        quantityPlus.addEventListener('click', () => {
            let quantity = +quantityField.value;
            quantity++

            quantityField.value = quantity;
            quantityField.dispatchEvent(new Event('change'));
        });

        remove.addEventListener('click', () => {
            quantityField.value = 0;
            quantityField.dispatchEvent(new Event('change'));
        });

        quantityField.addEventListener('change', async () => {
            let quantity = +quantityField.value;
            quantity = Math.max(0, quantity);

            if(quantity !== +quantityField.value) {
                quantityField.value = quantity;
            }

            if(quantity !== latestRequestQuantity) {
                try {
                    let response = await axios.post('/cart/update.js', {updates: {[id]: quantity}});

                    if(response.status === 200) {
                        if(quantity !== 0) {
                            price.innerText = app.currency(response.data.items.find(item => item.id === id).final_line_price);
                        } else {
                            cartProduct.remove();
                        }

                        cartTotalPrice.innerText = app.currency(response.data.items_subtotal_price);

                        if(response.data.item_count === 0) {
                            cartCheckout.setAttribute('disabled', '');
                            cartEmpty.classList.remove('d-none');
                        }

                        latestRequestQuantity = quantity;
                    }
                } catch(e) {}
            }
        });
    };

    cartProducts.map(cartProductInit);
}
